import { AddInvoiceRequest } from './add.invoice.request';

// INVOICE
export interface IEditInvoiceRequest {
    InvoiceID: number;
}

export class EditInvoiceRequest extends AddInvoiceRequest implements IEditInvoiceRequest {
    InvoiceID: number;
}

